// API Configuration
export const API_CONFIG = {
  // Base URL for the API
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3003',

  // Base URL for the public restaurant website (used to link to uploaded files like doctor certificates)
  SITE_URL: process.env.REACT_APP_SITE_URL || 'http://localhost:8080',

  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      VALIDATE: '/auth/validate',
      RESET_PASSWORD: '/auth/reset-password',
      UPDATE_PASSWORD: '/auth/update-password',
    },
    USERS: {
      BASE: '/users',
      BY_ID: (id: number) => `/users/${id}`,
    },
    EMPLOYEES: {
      BASE: '/employees',
      BY_ID: (id: number) => `/employees/${id}`,
      IMPORT: '/employees/import',
    },
    TIPOUT: {
      BASE: '/tipout-logs',
      SUMMARY: '/tipout-logs/summary',
      CURRENT_DATE: '/tipout-logs/current-date',
    },
    LOTTERY: {
      BASE: '/lottery',
    },
    LOTTERY_PURCHASE: {
      BASE: '/lottery-purchase',
      BY_ID: (id: number) => `/lottery-purchase/${id}`,
    },
    CASH_DEPOSITS: {
      BASE: '/cash-deposits',
      BY_ID: (id: number) => `/cash-deposits/${id}`,
    },
    THANKSGIVING_TIMING_WINDOWS: {
      BASE: '/thanksgiving-timing-windows',
      BY_ID: (id: number) => `/thanksgiving-timing-windows/${id}`,
    },
    BALANCE: {
      BASE: '/balance',
      CURRENT_DATE: '/tipout-logs/current-date', // Using same endpoint as tipout
    },
    SITE_CONFIG: {
      DAILY_SPECIAL: '/site-config/daily-special',
    },
    WEBSITE_FORMS: {
      EVENT_RESERVATIONS: '/website-forms/event-reservations',
      WORK_WITH_US: '/website-forms/work-with-us',
      SICK_LEAVE: '/website-forms/sick-leave',
      OPEN_TABLE_RESERVATIONS: '/website-forms/open-table-reservations',
    },
    EVENT_FORMS: {
      BASE: '/event-forms',
      BY_ID: (id: number) => `/event-forms/${id}`,
    },
    PERFORMANCE_EVENTS: {
      BASE: '/performance-events',
      BY_ID: (id: number) => `/performance-events/${id}`,
      BY_SERIES_ID: (seriesId: string) => `/performance-events/series/${seriesId}`,
    },
    RESERVATION_FORMS: {
      BASE: '/reservation-forms',
      BY_ID: (id: number) => `/reservation-forms/${id}`,
    },
    THANKSGIVING_RESERVATIONS: {
      BASE: '/thanksgiving-reservations',
      BY_ID: (id: number) => `/thanksgiving-reservations/${id}`,
    },
    MISC_PURCHASES: {
      BASE: '/misc-purchases',
      BY_ID: (id: number) => `/misc-purchases/${id}`,
    },
    DONATIONS: {
      BASE: '/donations',
      BY_ID: (id: number) => `/donations/${id}`,
    },
    VACATION: {
      BASE: '/vacation',
      BY_ID: (id: number) => `/vacation/${id}`,
    },
    SICK_FORM: {
      BASE: '/sick-form',
      BY_ID: (id: number) => `/sick-form/${id}`,
    },
    VENDORS: {
      BASE: '/vendors',
      BY_ID: (id: number) => `/vendors/${id}`,
    },
    OPENTABLE_IMPORTS: {
      BASE: '/opentable-imports',
      UPLOAD: '/opentable-imports/upload',
      BY_ID: (id: number) => `/opentable-imports/${id}`,
    },
  },
  
  // Request Configuration
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Timeout settings
  TIMEOUT: 10000, // 10 seconds
};

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = (token: string) => ({
  ...API_CONFIG.DEFAULT_HEADERS,
  'Authorization': `Bearer ${token}`,
});

// Helper function to get default headers
export const getDefaultHeaders = () => API_CONFIG.DEFAULT_HEADERS;
